export default __webpack_public_path__ + "static/CactusJackAlternate-6792a06d5b5d717b1cc535d287c0ae8d.woff";